module.exports = __webpack_public_path__ + "images/img-3u__AjQ.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/75.jpg
// module id = 2014
// module chunks = 0